import React, { useEffect, useState } from 'react';
import RegionLanguageModal from './RegionLanguageModal';
import { useRegion } from '../../Provider/RegionProvider';
import { useTranslation } from 'react-i18next';
import { detectCountryByIp, isIpAddress } from '../../util/functions';

const PROMPT_STORAGE_KEY = 'app:geoRegionPrompted';
const TARGET_COUNTRY_CODES = ['PE', 'SG'];

const GeoRegionPrompt = () => {
  const { setCountry } = useRegion();
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [detectedCode, setDetectedCode] = useState(null);

  useEffect(() => {
    const hostname = window?.location?.hostname || '';
    const isCarsnusCom = hostname.replace(/^www\./, '') === 'carsnus.com';
    console.log("🚀 ~ GeoRegionPrompt ~ isCarsnusCom:", isCarsnusCom)
    const isLocalhost = hostname === 'localhost' || isIpAddress(hostname);

    if (!isCarsnusCom || isLocalhost) return;
    if (sessionStorage.getItem(PROMPT_STORAGE_KEY)) return;

    (async () => {
      const code = await detectCountryByIp();
      console.log("🚀 ~ GeoRegionPrompt ~ code:", code)
      if (code && TARGET_COUNTRY_CODES.includes(code)) {
        sessionStorage.setItem(PROMPT_STORAGE_KEY, '1');
        setDetectedCode(code);
        setOpen(true);
      }
    })();
  }, []);

  const handleApply = (newCountry, newLang) => {
    if (newCountry) {
      setCountry(newCountry);
      const hostname = window?.location?.hostname || '';
      const isLocalhost = hostname === 'localhost' || isIpAddress(hostname);
      if (!isLocalhost && newCountry.domain) {
        window.open(newCountry.domain, '_self');
      }
    }
    if (newLang) {
      localStorage.setItem('i18nLng', newLang.code);
      i18n.changeLanguage(newLang.code);
    }
  };

  if (!detectedCode) return null;

  return (
    <RegionLanguageModal
      visible={open}
      onClose={() => setOpen(false)}
      initialTab='country'
      selectedCountry={detectedCode}
      onApply={handleApply}
    />
  );
};

export default GeoRegionPrompt;
